import { backendApi } from "../dynamicBAseQuery";

export const AdminApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        AdminList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `AdminList`,
                body: {...args}
            })
        }),

    })
})
export const {
    useAdminListMutation,
}=AdminApi;